import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const notascobroCodServicioSlice = createSlice({
  name: 'notascobroCodServicio',
  initialState: {
    rangoId: 0,
    data: null,
    notascobro: []
  },
  reducers: {
    setNotasCobroCodServicio: (state, action) => {
      state.rangoId = action.payload.rangoId;
      state.data = action.payload.data;
      state.notascobro = action.payload.notascobro;
    }
  }
});

export const { setNotasCobroCodServicio } = notascobroCodServicioSlice.actions;

// Action Creators
export const getNotasCobroCodServicio = (comunidadId, codigo, rango) => async (dispatch, getState) => {
  const inicio = rango.inicio;
  const fin = rango.fin;
  let item = LocalCache.get(`KEY:notascobroCodServicio&comunidad=${comunidadId}&codigo=${codigo}&inicio=${inicio}&fin=${fin}`);
  if (item) {
    dispatch(setNotasCobroCodServicio(item));
  } else {
    try {
      const response = await API.get('ePlat', `/notascobro-cod-servicio?comunidad=${comunidadId}&codigo=${codigo}&inicio=${inicio}&fin=${fin}`);
      let notascobro = { rangoId: rango.id, data: response.data, notascobro: response.notascobro };
      dispatch(setNotasCobroCodServicio(notascobro));
      LocalCache.put(`KEY:notascobroCodServicio&comunidad=${comunidadId}&codigo=${codigo}&inicio=${inicio}&fin=${fin}`, notascobro);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getNotasCobroCodServicio()', error);
    }
  }
};

export default notascobroCodServicioSlice.reducer;
